module.exports = __webpack_public_path__ + "img/DFDBB7_F9F8E3_B5AF86_BCBC8C-256px.db874303.png";